import styled from 'styled-components'
import { Col } from 'react-styled-flexboxgrid'
import { LinkExternal } from 'styled-icons/octicons/LinkExternal'
import variables from '../../styles/variables'
import { TextWrapper } from '../../styles/base'
import { headerStyles } from '../../styles/global'
import { Heading } from '..'

export const IntroContainer = styled.div`
  width: 100%;
  background: ${variables.colors.silverTree.darker};
  padding-bottom: 20px;
  padding-top: 40px;
  position: relative;

  @media ${variables.media.sm} {
    padding-top: 70px;
  }
`

export const IntroSection = styled(TextWrapper)`
  background: ${variables.colors.silverTree.darker};
  color: white;
`

export const IntroHeader = styled(Heading)`
  ${headerStyles.headerLarge};
  word-wrap: nowrap;
  animation: slideUp 0.5s ease-in-out;
`

export const IntroTagline = styled.p`
  color: ${variables.colors.silverTree.medium};
  font-size: 1.2rem;
  margin-bottom: 40px;
  max-width: 500px;
  animation: slideUp 0.5s ease-in-out 0.2s;
  animation-fill-mode: forwards;
  opacity: 0;
`
export const ButtonContainer = styled.div`
  margin-top: 50px;
  margin-bottom: 20px;
  animation: fadeIn 0.5s ease-in-out 0.3s;
  animation-fill-mode: forwards;
  opacity: 0;

  display: flex;
  flex-wrap: wrap;

  > *:not(:last-child) {
    margin-right: 15px;
  }

  button {
    margin-bottom: 14px;
    position: relative;
  }
`

export const LinkExternalIcon = styled(LinkExternal)`
  width: 16px;
  height: 16px;
  margin-left: 6px;
  transform: translateY(-1px);
`

export const LogoContainer = styled.div`
  width: 100%;
  margin-top: 60px;
  margin-bottom: 30px;
  height: 60px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  animation: fadeIn 0.5s ease-in-out 0.5s;
  animation-fill-mode: forwards;
  opacity: 0;

  img {
    height: 60px;
    padding: 0;
    margin: 0;
  }
`

export const IntroSectionAnimationCenterer = styled(Col)`
  display: flex;
  justify-content: center;
`

export const IntroSectionAnimationContainer = styled.div`
  max-width: 500px;
  max-height: 500px;
  position: relative;
  animation: fadeIn 0.5s ease-in-out 0.8s;
  animation-fill-mode: forwards;
  opacity: 0;
`

export const IntroSectionSideSquare = styled.img`
  display: none;
  visibility: hidden;

  @media ${variables.media.sm} {
    display: block;
    visibility: visible;
    position: absolute;
    bottom: -40px;
    right: 10px;
    transform: translate(50%, 50%) rotate(45deg);
    z-index: 1;
    height: 100px;
  }
`

export const RequestAccessFormContainer = styled.div`
  width: 100%;
  margin-top: 50px;
  margin-bottom: 20px;
  animation: fadeIn 0.5s ease-in-out 0.3s;
  animation-fill-mode: forwards;
  opacity: 0;
  
  display: flex;
  flex-wrap: wrap;
  
  form {
    width: 100%;
  }
`

export const CustomForm = styled.div`
  display: flex;
  align-items: center;
  
  input {
    margin: 0 15px 0 0;
  }
  
  button {
    margin: 0;
    padding: 0.6rem 1rem;
  }
`
